import getGdprPreferences from './getGdprPreferences.js';

export default function isGdprAnalyticsEnabled(): boolean {
  const categories: string[] = getGdprPreferences()?.categories || [];
  return categories.indexOf('analytical') > -1;
}
